import { render, staticRenderFns } from "./InstructionModal.vue?vue&type=template&id=882e07e6&v-if=visible%20%3D%3D%20true&"
import script from "./InstructionModal.vue?vue&type=script&lang=js&"
export * from "./InstructionModal.vue?vue&type=script&lang=js&"
import style0 from "./InstructionModal.vue?vue&type=style&index=0&id=882e07e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports